module.exports = __webpack_public_path__ + "static/media/Law of Small Numbers - nathan-dumlao-pMW4jzELQCw-unsplash.3b3137e7.jpg";